import React from 'react';

import classNames from 'classnames';
import {
  faArrowDownLeftAndArrowUpRightToCenter, faArrowLeft, faArrowUpRightAndArrowDownLeftFromCenter, faPenToSquare,
  faVolume, faVolumeSlash, faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';

import SparkBadge from '../spark_badge';
import { useConversationContext } from '../conversation_context';

interface Props {
  fullscreen?: boolean;
  onClose?: () => void;
  onToggleFullscreen?: () => void;
}

export default function AssistantHeader({ fullscreen = false, onClose, onToggleFullscreen }: Props) {
  const {
    busy, isAdmin, messages, speaking, startNewChat, toggleAdminDetails, toggleVoice, ttsSupported, voiceEnabled,
  } = useConversationContext();
  const newChatDisabled = busy || messages.length === 0;
  const fullscreenLabel = fullscreen ? 'Exit full screen' : 'Full screen';

  return (
    <Card.Header className="d-flex align-items-center gap-2">
      {fullscreen && onToggleFullscreen && (
        <Button
          appearance="muted"
          aria-label="Back to rail"
          icon={faArrowLeft}
          size="sm"
          tooltip="Back to rail"
          variant="ghost"
          onClick={onToggleFullscreen}
        />
      )}
      <SparkBadge onClick={isAdmin ? toggleAdminDetails : undefined} />
      <div className="flex-grow-1 lh-sm text-truncate">
        <div className="fw-semibold">Otto</div>
        <div className="small text-muted">Your Buildout assistant</div>
      </div>
      <div className="d-flex align-items-center gap-1">
        {ttsSupported && (
          <Button
            appearance="muted"
            aria-label={voiceEnabled ? 'Mute voice replies' : 'Unmute voice replies'}
            className={classNames({ 'text-primary': speaking && voiceEnabled })}
            icon={voiceEnabled ? faVolume : faVolumeSlash}
            size="sm"
            tooltip={voiceEnabled ? 'Mute voice replies' : 'Unmute voice replies'}
            variant="ghost"
            onClick={toggleVoice}
          />
        )}
        <Button
          appearance="muted"
          aria-label="New chat"
          disabled={newChatDisabled}
          icon={faPenToSquare}
          size="sm"
          tooltip="New chat"
          variant="ghost"
          onClick={startNewChat}
        />
        {onToggleFullscreen && (
          <Button
            appearance="muted"
            aria-label={fullscreenLabel}
            icon={fullscreen ? faArrowDownLeftAndArrowUpRightToCenter : faArrowUpRightAndArrowDownLeftFromCenter}
            size="sm"
            tooltip={fullscreenLabel}
            variant="ghost"
            onClick={onToggleFullscreen}
          />
        )}
        {onClose && (
          <Button
            appearance="muted"
            aria-label="Close"
            icon={faXmark}
            size="sm"
            variant="ghost"
            onClick={onClose}
          />
        )}
      </div>
    </Card.Header>
  );
}
